import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";

import FormPermissions from './FormPermissions'
import FormLoader from './FormLoader'


const Component = () => {
    return (
        <>
            <div className="d-lg-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="mb-4 mb-lg-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item href={Routes.Dashboard.path}><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.Users.path}>Users</Breadcrumb.Item>
                        <Breadcrumb.Item active>User</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>User Profile</h4>
                </div>
            </div>
            <FormPermissions>
                <FormLoader />
            </FormPermissions>
        </>
    );
};

export default Component;
